import { render, staticRenderFns } from "./CabinAvailable.vue?vue&type=template&id=52891c72&scoped=true"
import script from "./CabinAvailable.vue?vue&type=script&lang=js"
export * from "./CabinAvailable.vue?vue&type=script&lang=js"
import style0 from "./CabinAvailable.vue?vue&type=style&index=0&id=52891c72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52891c72",
  null
  
)

export default component.exports